import { memo } from "react";
import type { BatchJobPanelProps } from "../../batch_job_kind_contract";
import { FieldReannotationPanelBody } from "./FieldReannotationPanelBody";
import { useFieldReannotationPanel } from "./useFieldReannotationPanel";

/** Results panel for a field_reannotation batch job. */
export const FieldReannotationPanel = memo(function FieldReannotationPanel({
  job,
}: BatchJobPanelProps) {
  const panel = useFieldReannotationPanel(job);
  return <FieldReannotationPanelBody panel={panel} />;
});
